import React, { Component } from 'react'

interface BoldProps {
  text: string
}

export default class Bold extends Component<BoldProps> {
  render () {
    return (
      <span
        className="font-medium">
        {this.props.text}
      </span>
    )
  }
}
